import { fork } from 'redux-saga/effects';

import SettingGateway from '~apis/setting';
import { RootSagaReturnType } from '~types/saga';

import watchGetSettings from './getSettings';
import watchUpdateSettings from './updateSettings';
import watchGetApiKeySettings from './getApiKeySettings';
import watchUpdateApiKeySettings from './updateApiKeySettings';
import watchGetPendingProductListing from './getPendingProductListing';
import watchGetPendingProjectListing from './getPendingProjectListing';
import watchGetApiKeyHistoryListing from './getApiHistoryListing';
import watchCreateProductSettings from './createProductSettings';
import watchCreateAdminSettings from './createAdminSettings';
import watchGetSilverApiKeySettings from './getSilverApiKeySettings';
import watchUpdateSilverApiKeySettings from './updateSilverApiKeySettings';
import watchGetSilverApiKeyHistoryListing from './getSilverApiHistoryListing';

export default (api: SettingGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetSettings, api);
        yield fork(watchUpdateSettings, api);
        yield fork(watchGetApiKeySettings, api);
        yield fork(watchUpdateApiKeySettings, api);
        yield fork(watchGetPendingProductListing, api);
        yield fork(watchGetPendingProjectListing, api);
        yield fork(watchGetApiKeyHistoryListing, api);
        yield fork(watchCreateProductSettings, api);
        yield fork(watchCreateAdminSettings, api);
        yield fork(watchGetSilverApiKeySettings, api);
        yield fork(watchUpdateSilverApiKeySettings, api);
        yield fork(watchGetSilverApiKeyHistoryListing, api);
    }

    return {
        rootSaga,
    };
};
